module.exports = __webpack_public_path__ + "img/ORDER-ALL.f6233b8c.png";